import { render } from "./ExtensionCallback.vue?vue&type=template&id=0f760a6a&scoped=true"
import script from "./ExtensionCallback.vue?vue&type=script&lang=js"
export * from "./ExtensionCallback.vue?vue&type=script&lang=js"

import "./ExtensionCallback.vue?vue&type=style&index=0&id=0f760a6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f760a6a"]])

export default __exports__